import { CopyToClipboard, InputDescription, LinkOutIcon, TextInput } from '@movingimage-evp/mi-ui-component-library';
import { useTranslation } from 'react-i18next';
import { getLanguageKey } from 'src/utils';

import styles from './ai-subtitles-editor-info.module.css';

type Props = {
  label: 'primary' | 'backup';
  language?: string | null;
  editorUrl?: string | null;
  accessPin?: string | null;
};

export function EditorSection({ label, language, editorUrl, accessPin }: Props) {
  const { t } = useTranslation();

  if (!editorUrl || !accessPin) return null;

  return (
    <div className={styles.section}>
      <span>
        {t(`common.languages.${getLanguageKey(language || '')}`)} - {t(`common.${label}`)}
      </span>

      <InputDescription
        inputId={`ai-live-editor-url-${language}-${label}`}
        label={
          <span className={styles.labelWithIcon}>
            {t('manager.webcastSetup.summary.aiSubtitles.editorUrl.label')}
            <a href={editorUrl} target="_blank" rel="noopener noreferrer">
              <LinkOutIcon />
            </a>
          </span>
        }
        helpMessage={t('manager.webcastSetup.summary.aiSubtitles.editorUrl.helpMessage')}
      >
        <TextInput
          id={`ai-live-editor-url-${language}-${label}`}
          data-testid={`ai-live-editor-url-${language}-${label}`}
          value={editorUrl}
          readOnly
        >
          <CopyToClipboard value={editorUrl} notificationPosition="left" />
        </TextInput>
      </InputDescription>

      <InputDescription
        inputId={`ai-live-editor-pin-${language}-${label}`}
        label={t('manager.webcastSetup.summary.aiSubtitles.pin.label')}
      >
        <TextInput
          id={`ai-live-editor-pin-${language}-${label}`}
          data-testid={`ai-live-editor-pin-${language}-${label}`}
          value={accessPin}
          readOnly
        >
          <CopyToClipboard value={accessPin} notificationPosition="left" />
        </TextInput>
      </InputDescription>
    </div>
  );
}
